<template>

  <span class="phone-input">

    <div class="mdl-textfield mdl-js-textfield mdl-textfield prefix" @click="showPrefixMenu" ref="prefix"
         :class="{'is-invalid': prefixInvalid }" >
      <span class="value">{{ prefix.length > 0 ? prefix : "+??" }}</span>
      <span class="more">
        <span>▾</span>
      </span>
    </div>

    <div class="mdl-textfield mdl-js-textfield mdl-textfield mdl-textfield--floating-label number">
     <input class="mdl-textfield__input" type="text" id="number" v-model="number"
             v-bind:required="required" ref="number"
            pattern="[0-9 #+-]{3,}">
      <label class="mdl-textfield__label" for="number">{{ label }}</label>
    </div>

  </span>

</template>

<script>
  import api from "api"
  import countries from "../../config/countries"
  import overlayModel from "./overlayModel.js"
  import PhonePrefixPicker from "./PhonePrefixPicker.vue"

  require("flag-icon-css/css/flag-icon.css")

  export default {
    name: 'phone-input',
    props: {
      value: {
      },
      required: {
        type: Boolean,
        required: true
      },
      label: {
        type: String
      },
      invalid: {
        type: Boolean
      }
    },
    data () {
      let sep = this.value.indexOf(' ')
      let empty = sep == -1
      let prefix = empty ? "" : this.value.slice(0, sep)
      let number = empty ? "" : this.value.slice(sep+1)
      let country = countries.filter(c=>c.dial_code==prefix)[0]
      return {
        prefix, number,
        isoCode: country ? country.isoCode : null,
        overlayStackId: null,
        lastCloseTime: 0
      }
    },
    reactive: {
      geoIpIsoCode: ["geoip", "country"]
    },
    computed: {
      liveValue() {
        return (this. prefix + " " + this.number).trim()
      },
      prefixInvalid() {
        return this.invalid && this.prefix.trim().length==0
      }
    },
    watch: {
      geoIpIsoCode(iso) {
        if(!this.isoCode) {
          this.isoCode = iso
          this.prefix = countries.filter(country=> country.code == iso)[0].dial_code
        }
      },
      liveValue(value) {
        this.$emit('update:value', value)
      },
      invalid(v) {
        if(!v) return
        if(!this.number.match(/^[0-9 #+-]{3,}$/)) {
          this.$refs.number.parentElement.setAttribute('class',
            this.$refs.number.parentElement.getAttribute('class')+' is-invalid')
        }
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    created() {
    },
    mounted() {
      componentHandler.upgradeAllRegistered()
    },
    methods: {
      showPrefixMenu() {
        if(this.overlayStackId === null &&  Date.now() - this.lastCloseTime > 230) {
          this.overlayStackId = overlayModel.show({
            component: PhonePrefixPicker,
            props: {
              anchor: overlayModel.elementAnchor(this.$refs.prefix)
            },
            on: {
              selected: (code) => this.prefix = code
            }
          })
        } else {
          overlayModel.close(this.overlayStackId)
          this.overlayStackId = null
          this.lastCloseTime = Date.now()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .phone-input {
    display: inline-block;
    position: relative;
  }

  .prefix {
    width: 60px;
    border-bottom: 1px solid rgba(0,0,0,.12);
    position: relative;
    top: 0px;
    padding: 0;
    padding-top: 4px;
    padding-bottom: 4px;
    margin-top: 16px;
    cursor: default;
    vertical-align: baseline;
  }
  .prefix.is-invalid {
    border-bottom: 1px solid #d50000;
  }
  .prefix .more {
    float: right;
    cursor: default;
  }

  .number {
    width: calc(100% - 74px);
    margin-left: 10px;
  }


</style>



// WEBPACK FOOTER //
// PhoneInput.vue?19c3624f